import {Injectable, signal, Signal} from '@angular/core';

export interface Notification {
    message: string;
    type: 'error' | 'success' | 'info';
    id: number;
}

// Wie der Rest der Anwendung (EmployeeService, DatevAuthStatusService, EmployeeSyncStatusService,
// ...) hält dieser Service seinen Zustand direkt als Signal statt als BehaviorSubject. Add/
// remove/Auto-Timeout sind reine Update-Operationen auf einem Array - dafür reicht signal.update()
// vollständig aus, ein zusätzliches Observable (z.B. via toObservable()) wird nirgends benötigt.
// NotificationComponent liest das Signal direkt im Template statt es manuell zu abonnieren -
// dadurch entfällt auch die bisher fehlende Unsubscribe-Logik (siehe Git-Historie) vollständig,
// da es ohne Subscription keine Subscription zum Aufräumen mehr gibt.
@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    private notifications = signal<Notification[]>([]);
    private counter = 0;

    getNotifications(): Signal<Notification[]> {
        return this.notifications.asReadonly();
    }

    show(message: string, type: 'error' | 'success' | 'info' = 'info'): void {
        const id = this.counter++;

        this.notifications.update(current => [
            ...current,
            {message, type, id}
        ]);

        // Auto-remove after 5 seconds
        setTimeout(() => {
            this.remove(id);
        }, 10000);
    }

    remove(id: number): void {
        this.notifications.update(current =>
            current.filter(notification => notification.id !== id)
        );
    }
}